import React from "react";
import Grid from "@mui/material/Grid";
import FormControl from "@mui/material/FormControl";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import { Button } from "@mui/material";
import useChangePasswordController from "view-models/Common/ChangePassword/useChangePasswordController";
import CircularLoader from "../CircularLoader";

const ChangePassword = () => {
  const {
    formik,
    showPassword,
    handleMouseDownPassword,
    handleClickShowPassword,
    isChangePassLoading,
    handleClickShowPassword1,
    handleClickShowPassword2,
    showPassword1,
    showPassword2,
  } = useChangePasswordController();

  return (
    <div className="change-pwd-wrap">
      <div className="bs-form">
        <Grid
          container
          rowSpacing={{ md: 2.5, xs: 3 }}
          columnSpacing={{ md: 2.5, xs: 2.5 }}
        >
          <Grid item xs={12} sm={12}>
            <div className="form-group">
              <div className="input-label">
                <p className="label">Old Password</p>
              </div>
              <FormControl className="form-control">
                <OutlinedInput
                  id="outlined-adornment-old-password"
                  // type={"password"}
                  type={showPassword ? "text" : "password"}
                  name="oldPassword"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                        disableRipple
                      >
                        {showPassword ? (
                          <span className="icon icon-eye-open"></span>
                        ) : (
                          <span className="icon icon-eye-close"></span>
                        )}
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </FormControl>
              {formik?.errors?.oldPassword && formik?.touched?.oldPassword && (
                <span className="error-txt">{formik?.errors?.oldPassword}</span>
              )}
            </div>
          </Grid>
          <Grid item xs={12} sm={12}>
            <div className="form-group">
              <div className="input-label">
                <p className="label">New Password</p>
              </div>
              <FormControl className="form-control">
                <OutlinedInput
                  id="outlined-adornment-password"
                  type={showPassword1 ? "text" : "password"}
                  name="newPassword"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword1}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                        disableRipple
                      >
                        {showPassword1 ? (
                          <span className="icon icon-eye-open"></span>
                        ) : (
                          <span className="icon icon-eye-close"></span>
                        )}
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </FormControl>
              {formik?.errors?.newPassword && formik?.touched?.newPassword && (
                <span className="error-txt">{formik?.errors?.newPassword}</span>
              )}
            </div>
          </Grid>
          <Grid item xs={12} sm={12}>
            <div className="form-group">
              <div className="input-label">
                <p className="label">Confirm New Password</p>
              </div>
              <FormControl className="form-control">
                <OutlinedInput
                  id="outlined-adornment-new-password"
                  // type={"password"}
                  type={showPassword2 ? "text" : "password"}
                  name="confirmNewPassword"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword2}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                        disableRipple
                      >
                        {showPassword2 ? (
                          <span className="icon icon-eye-open"></span>
                        ) : (
                          <span className="icon icon-eye-close"></span>
                        )}
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </FormControl>
              {formik?.errors?.confirmNewPassword &&
                formik?.touched?.confirmNewPassword && (
                  <span className="error-txt">
                    {formik?.errors?.confirmNewPassword}
                  </span>
                )}
            </div>
          </Grid>
        </Grid>
        <div className="form-action">
          <div className="action-btn-wrap">
            <Button
              variant="contained"
              className="bs-btn"
              onClick={formik.handleSubmit}
              disabled={isChangePassLoading ? true : false}
              endIcon={
                isChangePassLoading ? (
                  <CircularLoader loaderClr={"var(--white)"} />
                ) : (
                  ""
                )
              }
            >
              <span className="text">Submit</span>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
